var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgOffer = function SvgOffer(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#clip0_2747_12019)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M12.785 19.513c-.652.65-1.706.65-2.355 0l-9.178-8.607C.74 10.424.127 9.512.083 8.81-.035 6.911.048 3.274.106 1.346A1.366 1.366 0 0 1 1.421.038C3.884-.019 9.103-.08 9.588.405L19.695 9.55c.649.65.06 2.292-.594 2.944l-6.316 7.02ZM4.743 2.831a1.407 1.407 0 1 0-1.992 1.99 1.407 1.407 0 0 0 1.992-1.99Z",
    fill: "currentColor"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "clip0_2747_12019"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "white",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgOffer;